import { render, staticRenderFns } from "./SImage.vue?vue&type=template&id=f3627078&scoped=true"
import script from "./SImage.vue?vue&type=script&lang=js"
export * from "./SImage.vue?vue&type=script&lang=js"
import style0 from "./SImage.vue?vue&type=style&index=0&id=f3627078&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3627078",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yanchenrong/code/youxiang/muying/muying-admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f3627078')) {
      api.createRecord('f3627078', component.options)
    } else {
      api.reload('f3627078', component.options)
    }
    module.hot.accept("./SImage.vue?vue&type=template&id=f3627078&scoped=true", function () {
      api.rerender('f3627078', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/page/modules/editor/modules/SImage.vue"
export default component.exports